import React, { useRef, useState, useEffect } from 'react';
import { OpsDashboardAction } from '../../../Services/_actions/OpsDashboard/OpsDashboard.actions';
import SelectDropdown from '../../../components/Shared/SelectDropdown';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
    QuetionsBySectorAtom,
    UserMinimalListAtom,
    alertAtom,
    B2bFormDataAtom,
    userSupplierListAtom,
} from '../../../Services/_states';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { dateFormate, renderToolTip } from '../../../utils/helper';
import { ConstantActions } from '../../../Services/_actions';
import ErrorWrapper from '../../Shared/ErrorWrapper/index';
import ModalForms from '../../Shared/Modals';
import SweetAlert from '../../Shared/Notification';
import { useNavigate } from 'react-router';
import InfoIcon from '@mui/icons-material/Info';

const infoIcon = <InfoIcon color="black" size={16} style={{ cursor: 'pointer' }} />;


const B2bLeadForm = () => {
    const actions = OpsDashboardAction();
    const navigate = useNavigate();
    const constantActions = ConstantActions();
    const [formData, setFormData] = useRecoilState(B2bFormDataAtom);
    const [quetions, setQuestions] = useRecoilState(QuetionsBySectorAtom);
    const [organisationList, setOrganisationList] = useState([]);
    const userMinimalList = useRecoilValue(UserMinimalListAtom);
    const [isAlert, setIsAlert] = useRecoilState(alertAtom)
    const [formErrors, setFormErrors] = useState({});
    const [commentModalShow, setCommentModalShow] = useState(false);
    const [commentList, setCommentList] = useState([]);
    const [commentType, setCommentType] = useState('');
    const supplierList = useRecoilValue(userSupplierListAtom)

    const validateForm = () => {
        const errors = {};
        if (!formData?.sector_id) errors.sector_id = 'Sector is required';
        if (!formData?.call_back_preference) errors.call_back_preference = 'Status is required';
        if (!formData?.representative) errors.representative = 'Supplier Agency is required';
        if (!formData?.l1_answers) errors.l1_answers = 'L4 is required';
        if (!formData?.l1_answer_2) errors.l1_answer_2 = 'L5 is required';
        if (!formData?.l2_answers) errors.l2_answers = 'L6 is required';
        if (!formData?.supplier_id) errors.supplier_id = 'Supplier Type is required';

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSelectPrefferedCompany = (e) => {
        setFormData({
            ...formData,
            prefered_patners: e,
        });
    };

    const getUserMinimalList = (e) => {
        setFormErrors({ ...formErrors, representative: '' });
        setFormData({ ...formData, representative: e?.organisation_id });
        constantActions.getUserMinimalList(e?.organisation_id);
    };

    const updateLead = () => {
        let companyIds = formData?.prefered_patners?.map((obj) => obj.organisation_id);
        let newObj = { ...formData, preferred_company: companyIds };
        if (validateForm()) {
            actions.updateLeadData({
                requirements: [newObj],
            });
        }
    };
    const createLead = async () => {
        setIsAlert(true);
        let companyIds = formData?.prefered_patners?.map((obj) => obj.organisation_id);
        let newObj = { ...formData, prefered_patners: companyIds };
        if (validateForm()) {
            let res = await actions.createlead({ browsed_ids: [newObj], });
            if (res?.status === 200) {
                setFormData({ ...formData, id: res?.data?.data?.requermnet_id, varified_ops: 'no' })
                SweetAlert('Lead Created Successfully', 'success');
            }
            else SweetAlert('Lead Not Created', 'error')
        }
        setIsAlert(false);
    };

    const opsVerifyLead = async () => {
        setIsAlert(true);
        await actions.opsVerifyLead({ requirement_ids: [formData?.id] });
        setIsAlert(false);

    };

    const getComments = async (type) => {
        let res = '';
        setCommentType(type);
        if (type === 'Client') res = await actions.getComments(formData?.id);
        else res = await actions.getInteranlComments(formData?.id);
        setCommentList(res);
        setCommentModalShow(true);
    };

    const onSubmitComment = (comment) => {
        if (commentType === 'Client') {
            let data = { data: [{ comment: comment, pre_requirement_id: formData?.id }] };
            actions.addComment(data);
        } else {
            let data = { data: [{ comment: comment, requirement_id: formData?.id }] };
            actions.addInternalComment(data);
        }
        getComments(commentType);
    };

    const onRemoveComment = (item, indexToDelete) => {
        if (commentType === 'Client') {
            actions.removeComment(item?.id, formData?.id);
        } else {
            actions.removeInternalComment(item?.id, formData?.id);
        }
        setCommentList((prevData) => prevData.filter((obj, index) => obj?.id !== item?.id));
    };

    const getOrganisations = async () => {
        try {
            let res = await constantActions.getOrganisations();
            setOrganisationList(res);
        } catch (error) {
            console.log(error, "error");
        }
    }

    useEffect(() => {
        getOrganisations();
    }, [])

    const handleCreateSupplier = () => {
        navigate(`/r/edit-supplier/${formData?.phone_number}`);
    };


    return (
        <>
            <Form>
                <Row>
                    <Col sm={12} md={6} lg={4} xl={3}>
                        <Form.Group className="mb-3" controlId="subSector">
                            <Form.Label>Sub Sector</Form.Label>
                            <SelectDropdown
                                optionsData={[]}
                                selectedValue={null}
                                placeholder="Sub Sector"
                                label="Sub Sector"
                                id="subSector"
                                handleSelect={(e) => {
                                    setFormData({ ...formData, subSector: e });
                                }}
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={12} md={6} lg={4} xl={3}>
                        <Form.Group className="mb-3" controlId="SelectSociety">
                            <Form.Label>
                                Select Society <span className="required-field">*</span>
                            </Form.Label>
                            {supplierList && supplierList?.length > 0 ?
                                <SelectDropdown
                                    optionsData={supplierList}
                                    selectedValue={supplierList?.find(
                                        (obj) => obj?.supplier_id === formData?.supplier_id
                                    ) || null}
                                    placeholder="Select Society"
                                    label="Select Society"
                                    id="selectsociety"
                                    OptionLabel={'supplier_name'}
                                    OptionValue={'supplier_id'}
                                    handleSelect={(e) => {
                                        setFormData({
                                            ...formData,
                                            supplier_id: e?.supplier_id,
                                            supplier_type: e?.supplier_type,
                                        });
                                        setFormErrors({ ...formErrors, supplier_id: '' });
                                    }}
                                />
                                :
                                <Button variant="primary" onClick={handleCreateSupplier}>
                                    Create Supplier
                                </Button>
                            }
                            {formErrors?.supplier_id && <ErrorWrapper error={formErrors?.supplier_id} />}
                        </Form.Group>
                    </Col>
                    <Col sm={12} md={6} lg={4} xl={3}>
                        <Form.Group className="mb-3" controlId="currentPartner">
                            <Form.Label>Current Partner</Form.Label>
                            <SelectDropdown
                                optionsData={quetions?.companies_sector_wise}
                                selectedValue={quetions?.companies_sector_wise?.find(
                                    (obj) => obj.organisation_id === formData?.current_company
                                ) || null}
                                placeholder="Current Partner"
                                OptionLabel="name"
                                OptionValue="organisation_id"
                                label="currentPartner"
                                id="currentPartner"
                                handleSelect={(e) => {
                                    setFormData({ ...formData, current_company: e?.organisation_id });
                                }}
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={12} md={6} lg={4} xl={3}>
                        <Form.Group className="mb-3" controlId="Selectstatus">
                            <Form.Label>
                                Select Status <span className="required-field">*</span>
                            </Form.Label>
                            <SelectDropdown
                                optionsData={quetions?.callStatus}
                                selectedValue={quetions?.callStatus?.find(
                                    (obj) => obj?.value === formData?.call_back_preference
                                ) || null}
                                placeholder="Select Status"
                                label="SelectStatus"
                                id="SelectStatus"
                                handleSelect={(e) => {
                                    setFormData({ ...formData, call_back_preference: e?.value });
                                    setFormErrors({ ...formErrors, call_back_preference: '' })
                                }}
                            />
                            {formErrors?.call_back_preference && (
                                <ErrorWrapper error={formErrors?.call_back_preference} />
                            )}
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={6} lg={4} xl={3}>
                        <Form.Group className="mb-3" controlId="feedback">
                            <Form.Label>Feedback</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter Feedback"
                                value={formData?.current_patner_feedback}
                                onChange={(e) => {
                                    setFormData({ ...formData, current_patner_feedback: e?.target?.value });
                                }}
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={12} md={6} lg={4} xl={3}>
                        <Form.Group className="mb-3" controlId="questionL4">
                            <Form.Label>
                                L4 <span className="required-field">*</span>
                                {quetions?.question && quetions?.question['L4 question'] && (
                                    <span style={{ paddingLeft: '10px' }}>
                                        {renderToolTip(quetions?.question['L4 question'], infoIcon)}
                                    </span>
                                )}
                            </Form.Label>
                            <SelectDropdown
                                optionsData={quetions?.l4Answer}
                                selectedValue={quetions?.l4Answer?.find(
                                    (obj) => obj?.value === formData?.l1_answers
                                ) || null}
                                placeholder="L4 Answer"
                                label="L4 Answer"
                                id="L4Answer"
                                handleSelect={(e) => {
                                    setFormData({ ...formData, L4: e?.value, l1_answers: e?.value });
                                    setFormErrors({ ...formErrors, l1_answers: '' });
                                }}
                            />
                            {formErrors?.l1_answers && <ErrorWrapper error={formErrors?.l1_answers} />}
                        </Form.Group>
                    </Col>
                    <Col sm={12} md={6} lg={4} xl={3}>
                        <Form.Group className="mb-3" controlId="questionL5">
                            <Form.Label>
                                L5 <span className="required-field">*</span>
                                {quetions?.question && quetions?.question['L5 question'] && (
                                    <span style={{ paddingLeft: '10px' }}>
                                        {renderToolTip(quetions?.question['L5 question'], infoIcon)}
                                    </span>
                                )}
                            </Form.Label>
                            <SelectDropdown
                                optionsData={quetions?.l5Answer}
                                selectedValue={quetions?.l5Answer?.find(
                                    (obj) => obj?.value === formData?.l1_answer_2
                                ) || null}
                                placeholder="L5 Answer"
                                label="L5 Answer"
                                id="L5Answer"
                                handleSelect={(e) => {
                                    setFormData({ ...formData, L5: e?.value, l1_answer_2: e?.value });
                                    setFormErrors({ ...formErrors, l1_answer_2: '' });
                                }}
                            />
                            {formErrors?.l1_answer_2 && <ErrorWrapper error={formErrors?.l1_answer_2} />}
                        </Form.Group>
                    </Col>
                    <Col sm={12} md={6} lg={4} xl={3}>
                        <Form.Group className="mb-3" controlId="questionL6">
                            <Form.Label>
                                L6 <span className="required-field">*</span>
                                {quetions?.question && quetions?.question['L6 question'] && (
                                    <span style={{ paddingLeft: '10px' }}>
                                        {renderToolTip(quetions?.question['L6 question'], infoIcon)}
                                    </span>
                                )}
                            </Form.Label>
                            <SelectDropdown
                                optionsData={quetions?.l6Answer}
                                selectedValue={quetions?.l6Answer?.find(
                                    (obj) => obj?.value === formData?.l2_answers
                                ) || null}
                                placeholder="L6 Answer"
                                label="L6 Answer"
                                id="L6Answer"
                                handleSelect={(e) => {
                                    setFormData({ ...formData, L6: e?.value, l2_answers: e?.value });
                                    setFormErrors({ ...formErrors, l2_answers: '' });
                                }}
                            />
                            {formErrors?.l2_answers && <ErrorWrapper error={formErrors?.l2_answers} />}
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col sm={9} md={6} lg={3} xl={3}>
                        <Form.Group className="mb-3" controlId="prefferedPartner">
                            <Form.Label>Preffered Partner</Form.Label>
                            <SelectDropdown
                                optionsData={quetions?.companies_sector_wise}
                                selectedValue={formData?.prefered_patners}
                                placeholder="Preffered Partner"
                                OptionLabel="name"
                                OptionValue="organisation_id"
                                label="currentPartner"
                                id="currentPartner"
                                isMulti={true}
                                closeMenuOnSelect={false}
                                handleSelect={handleSelectPrefferedCompany}
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={9} md={6} lg={3} xl={3}>
                        <Form.Group className="mb-3" controlId="supplierAgency">
                            <Form.Label>
                                Supplier Agency <span className="required-field">*</span>
                            </Form.Label>
                            <SelectDropdown
                                optionsData={organisationList}
                                selectedValue={organisationList?.find(
                                    (obj) => obj?.organisation_id === formData?.representative
                                ) || null}
                                placeholder="Supplier Agency"
                                OptionLabel="name"
                                OptionValue="organisation_id"
                                label="Supplier Agency"
                                id="supplierAgency"
                                handleSelect={getUserMinimalList}
                            />
                            {formErrors?.representative && (
                                <ErrorWrapper error={formErrors?.representative} />
                            )}
                        </Form.Group>
                    </Col>
                    <Col sm={9} md={6} lg={3} xl={3}>
                        <Form.Group className="mb-3" controlId="supplierAgency">
                            <Form.Label>Agency User</Form.Label>
                            <SelectDropdown
                                optionsData={userMinimalList}
                                selectedValue={userMinimalList?.find(
                                    (obj) => obj?.username === formData?.relationship_manager
                                )}
                                placeholder="Agency User"
                                OptionLabel="first_name"
                                OptionValue="username"
                                addOptionLabel={['last_name']}
                                label="Agency User"
                                id="agencyUser"
                                handleSelect={(e) => {
                                    setFormData({ ...formData, relationship_manager: e?.username || null });
                                }}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                {formData?.id && (
                    <>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="prefferedPartner">
                                    <Form.Label>Comment</Form.Label>
                                    <div>
                                        <Button
                                            varient="primary"
                                            onClick={(e) => {
                                                getComments('Client');
                                            }}
                                        >
                                            View
                                        </Button>
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="prefferedPartner">
                                    <Form.Label>Internal comment</Form.Label>
                                    <div>
                                        <Button
                                            varient="primary"
                                            onClick={(e) => {
                                                getComments('Internal');
                                            }}
                                        >
                                            View
                                        </Button>
                                    </div>
                                </Form.Group>{' '}
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="prefferedPartner">
                                    <Form.Label>Price</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Enter Price"
                                        value={formData?.lead_price}
                                        onChange={(e) => {
                                            setFormData({ ...formData, lead_price: e?.target?.value });
                                        }}
                                    />
                                </Form.Group>{' '}
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="prefferedPartner">
                                    <Form.Label>Lead Id</Form.Label>
                                    <div>{formData?.id}</div>
                                </Form.Group>{' '}
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="prefferedPartner">
                                    <Form.Label>External Id</Form.Label>
                                    <div></div>
                                </Form.Group>{' '}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="prefferedPartner">
                                    <Form.Label>Lead Status</Form.Label>
                                    <div>{formData?.lead_status}</div>
                                </Form.Group>{' '}
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="prefferedPartner">
                                    <Form.Label>Submitted Date</Form.Label>
                                    <div>{dateFormate(formData?.lead_date, 'DD-MM-YYYY-hh:mm A')}</div>
                                </Form.Group>{' '}
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="prefferedPartner">
                                    <Form.Label>Ops Verify Date</Form.Label>
                                    <div>{dateFormate(formData?.varified_ops_date, 'DD-MM-YYYY-hh:mm A')}</div>
                                </Form.Group>{' '}
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="prefferedPartner">
                                    <Form.Label>Lead Given By</Form.Label>
                                    <div>
                                        {formData?.lead_by?.name}({formData?.lead_by?.mobile})
                                    </div>
                                </Form.Group>{' '}
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="prefferedPartner">
                                    <Form.Label>Ops Verified By</Form.Label>
                                    <div>
                                        {`${formData?.verified_ops_by_obj?.first_name ? formData?.verified_ops_by_obj?.first_name : ''} ${formData?.verified_ops_by_obj?.last_name ? formData?.verified_ops_by_obj?.last_name : ''}`}
                                    </div>
                                </Form.Group>{' '}
                            </Col>
                        </Row>
                    </>
                )}
                <div className="pt-3">
                    {' '}
                    {!formData?.id ? (
                        <Button
                            varient="primary"
                            onClick={() => {
                                createLead();
                            }}
                            disabled={isAlert}
                        >
                            Save
                        </Button>
                    ) : (
                        <>
                            <Button
                                varient="primary"
                                onClick={() => {
                                    updateLead();
                                }}
                            >
                                Update
                            </Button>
                            {formData?.varified_ops === 'no' && (
                                <Button
                                    style={{ marginLeft: '10px' }}
                                    varient="primary"
                                    disabled={isAlert}
                                    onClick={() => {
                                        opsVerifyLead();
                                    }}
                                >
                                    Ops Verify
                                </Button>
                            )}
                        </>
                    )}
                </div>
            </Form>
            {/* {
                commentModalShow && (
                    <ModalForms
                        show={commentModalShow}
                        handleClose={(e) => {
                            setCommentModalShow(false);
                        }}
                        modalBody={
                            <CommentModal
                                commentList={commentList}
                                onSubmitComment={onSubmitComment}
                                onRemoveComment={onRemoveComment}
                            />
                        }
                        modalHeader={'View Comment'}
                        modalId={'comment'}
                        modalclassName={''}
                        size="m"
                    />
                )
            } */}
        </>



    )
}

export default B2bLeadForm